module.exports = __webpack_public_path__ + "img/icon-ai-light-blue.f5e5ed85.svg";